module.exports = __webpack_public_path__ + "img/Cobranzas.5db5baf2.png";